import { HttpParams } from "@angular/common/http";
import { ICriteria } from "../../core/services/criteria.interface";

export class LiftParamCriteria implements ICriteria {
  pageSize: number = 10;
  page: number = 1;
  orderby: string = 'Code asc';

  paramsExport(): HttpParams {
    let params = new HttpParams()
      //.set('page', String(this.page))
      .set('orderby', this.orderby);
      //.set('pageSize', String(this.pageSize));

    return params;
  }
}
